/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Visibility_Feature_1Inputs */

const et_plan_visibility_feature_1 = /** @type {(inputs: Plan_Visibility_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sind leitakse lihtsamini siis, kui klient sinu teenust otsib`)
};

const en_plan_visibility_feature_1 = /** @type {(inputs: Plan_Visibility_Feature_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`People find you more easily when they search for your service`)
};

/**
* | output |
* | --- |
* | "People find you more easily when they search for your service" |
*
* @param {Plan_Visibility_Feature_1Inputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_visibility_feature_1 = /** @type {((inputs?: Plan_Visibility_Feature_1Inputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Visibility_Feature_1Inputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_visibility_feature_1(inputs)
	return en_plan_visibility_feature_1(inputs)
});